import { Megaphone, ExternalLink, Link2, Minus } from "lucide-react";
import { resolveMediaUrl } from "@/lib/ddfApi";

const LINK_META = {
  external: { icon: ExternalLink, label: "External URL" },
  promo: { icon: Link2, label: "Promo product" },
  none: { icon: Minus, label: "No link" },
};

function AdThumb({ ad }) {
  const src = resolveMediaUrl(ad.url) || ad.url;
  return ad.type === "video" ? (
    <video src={src} className="ddf-adi-thumb" muted playsInline />
  ) : (
    <img src={src} alt={ad.label} className="ddf-adi-thumb" />
  );
}

function LinkCell({ ad }) {
  const meta = LINK_META[ad.linkType] || LINK_META.none;
  const Icon = meta.icon;
  return (
    <div className="ddf-adi-link">
      <span className={`ddf-adi-chip ddf-adi-chip--${ad.linkType}`}><Icon size={11} /> {meta.label}</span>
      {ad.linkTarget && (
        ad.linkType === "external" ? (
          <a href={ad.linkTarget} target="_blank" rel="noopener noreferrer" className="ddf-adi-target">{ad.linkTarget}</a>
        ) : (
          <span className="ddf-adi-target">{ad.linkTarget}</span>
        )
      )}
    </div>
  );
}

export function AdInsightsTable({ rows = [] }) {
  const maxClicks = Math.max(1, ...rows.map((r) => r.clicks));
  return (
    <section className="ddf-an-chart-card" data-testid="an-ad-insights">
      <h4 className="ddf-an-chart-title">
        <Megaphone size={14} style={{ verticalAlign: "-2px", marginRight: 6 }} />
        Ad Click Insights
      </h4>
      <p className="ddf-adi-note">Ranked by clicks. Views = unique visits that saw the ad on screen; CTR = visits that clicked ÷ views.</p>
      {rows.length === 0 ? (
        <div className="ddf-an-empty">No banner ads yet.</div>
      ) : (
        <div className="ddf-adi-scroll">
          <table className="ddf-subs-table ddf-adi-table">
            <thead>
              <tr><th>#</th><th>Ad</th><th>Status</th><th>Links to</th><th>Views</th><th>Clicks</th><th>CTR</th></tr>
            </thead>
            <tbody>
              {rows.map((ad, i) => (
                <tr key={ad.adId} data-testid={`ad-insight-row-${i}`}>
                  <td>{i + 1}</td>
                  <td><div className="ddf-adi-ad"><AdThumb ad={ad} /><span>{ad.label}</span></div></td>
                  <td><span className={`ddf-adi-status ddf-adi-status--${ad.status}`}>{ad.status}</span></td>
                  <td><LinkCell ad={ad} /></td>
                  <td data-testid={`ad-insight-views-${i}`}>{ad.views}</td>
                  <td data-testid={`ad-insight-clicks-${i}`}>
                    <div className="ddf-adi-clicks">
                      <span>{ad.clicks}</span>
                      <div className="ddf-adi-bar"><div style={{ width: `${Math.round((ad.clicks / maxClicks) * 100)}%` }} /></div>
                    </div>
                  </td>
                  <td data-testid={`ad-insight-ctr-${i}`}>{ad.ctr}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
